import * as msal from "@azure/msal-browser";
const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
        authority: process.env.REACT_APP_AUTHORITY,
        redirectUri: process.env.REACT_APP_CUSTOM_DOMAIN_UI,
        postLogoutRedirectUri: process.env.REACT_APP_CUSTOM_DOMAIN_UI
    },
};

export const msalInstance = new msal.PublicClientApplication(msalConfig);
export const request = { scopes: [process.env.REACT_APP_SCOPE_EXTENSION] };